import { render, staticRenderFns } from "./ComprasList.vue?vue&type=template&id=348063e2&"
import script from "./ComprasList.vue?vue&type=script&lang=js&"
export * from "./ComprasList.vue?vue&type=script&lang=js&"
import style0 from "./ComprasList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports